import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { dynamicBaseQuery } from '~/api/common/dynamicBaseQuery';
import {
    SendChatRequest,
    SendChatResponse,
    SessionSummary,
    SessionDetail,
} from '~/features/chatbot/types/chatbot.types';

export const chatbotServiceApi = createApi({
    reducerPath: 'chatbotApi',
    baseQuery: dynamicBaseQuery,
    tagTypes: ['ChatSessions'],
    endpoints: (builder) => ({
        sendMessage: builder.mutation<SendChatResponse, SendChatRequest>({
            query: (data) => ({
                url: '/v1/admin/ai/chat',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['ChatSessions'],
        }),
        getSessions: builder.query<SessionSummary[], void>({
            query: () => ({
                url: '/v1/admin/ai/sessions',
                method: 'GET',
            }),
            providesTags: ['ChatSessions'],
        }),
        getSessionById: builder.query<SessionDetail, string>({
            query: (sessionId) => ({
                url: `/v1/admin/ai/sessions/${sessionId}`,
                method: 'GET',
            }),
        }),
        deleteSession: builder.mutation<void, string>({
            query: (sessionId) => ({
                url: `/v1/admin/ai/sessions/${sessionId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['ChatSessions'],
        }),
    }),
});

export const {
    useSendMessageMutation,
    useGetSessionsQuery,
    useGetSessionByIdQuery,
    useLazyGetSessionByIdQuery,
    useDeleteSessionMutation,
} = chatbotServiceApi;
